import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchUsers } from "../features/users/userSlice";

import UserForm from "./UserForm";
import UserTable from "./UserTable";

function Users() {

    const dispatch = useDispatch();

    const {
        loading,
        error
    } = useSelector(
        (state) => state.users
    );


    // =========================================================
    // FETCH USERS
    // =========================================================

    useEffect(() => {

        dispatch(fetchUsers());

    }, [dispatch]);


    // =========================================================
    // LOADING
    // =========================================================

    if (loading) {

        return (

            <div className="container-fluid mt-3">

                <div className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "300px" }}
                >

                    <div className="text-center">

                        <div
                            className="spinner-border text-primary"
                            role="status"
                        ></div>

                        <div className="mt-2 text-muted">

                            Loading users...

                        </div>

                    </div>

                </div>

            </div>

        );

    }


    // =========================================================
    // ERROR
    // =========================================================

    if (error) {

        return (

            <div className="container-fluid mt-3">

                <div className="alert alert-danger">

                    <i className="bi bi-exclamation-triangle-fill me-2"></i>

                    {error}

                </div>

            </div>

        );

    }


    // =========================================================
    // RENDER
    // =========================================================

    return (

        <div className="container-fluid mt-3">

            {/* =================================================
                PAGE HEADER
            ================================================== */}

            <div className="d-flex justify-content-between align-items-center mb-4">

                <div>

                    <h3 className="fw-bold mb-1">

                        <i className="bi bi-people-fill me-2"></i>

                        User Management

                    </h3>

                    <p className="text-muted mb-0">

                        Manage administrators, users and their permissions.

                    </p>

                </div>

            </div>


            {/* =================================================
                USER FORM + USER TABLE
            ================================================== */}

            <div className="row g-4">

                {/* =================================================
                    USER FORM
                ================================================== */}

                <div className="col-xl-4 col-lg-5">

                    <UserForm />

                </div>


                {/* =================================================
                    USER TABLE
                ================================================== */}

                <div className="col-xl-8 col-lg-7">

                    <UserTable />

                </div>

            </div>

        </div>

    );

}

export default Users;